<div class="flex flex-col gap-6 max-w-xl">
  <h2 class="text-xl font-semibold">Send marketing notification</h2>
  <p class="text-sm text-muted-color">
    Step 1: Configure filters and preview matching users. Step 2: Fill in channels and send.
  </p>

  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-1">
      <label class="text-sm font-medium">User status</label>
      <p-multiselect
        [options]="statusOptions"
        [ngModel]="selectedStatuses()"
        (ngModelChange)="selectedStatuses.set($event)"
        optionLabel="label"
        optionValue="value"
        placeholder="All statuses"/>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-sm font-medium">Payment status</label>
      <p-multiselect
        [options]="paymentStatusOptions"
        [ngModel]="selectedPaymentStatuses()"
        (ngModelChange)="selectedPaymentStatuses.set($event)"
        optionLabel="label"
        optionValue="value"
        placeholder="All payment statuses"/>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-sm font-medium">Profile complete</label>
      <p-select
        [options]="profileCompleteOptions"
        [ngModel]="profileComplete()"
        (ngModelChange)="profileComplete.set($event)"
        optionLabel="label"
        optionValue="value"
        placeholder="Any"/>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-sm font-medium">Last seen on app</label>
      <p-select
        [options]="lastSeenOnAppOptions"
        [ngModel]="lastSeenOnApp()"
        (ngModelChange)="lastSeenOnApp.set($event)"
        optionLabel="label"
        optionValue="value"
        placeholder="Any"/>
    </div>

    <div class="flex flex-row gap-4">
      <div class="flex flex-col gap-1 flex-1">
        <label class="text-sm font-medium">Last seen from</label>
        <p-datepicker
          [ngModel]="lastSeenFrom()"
          (ngModelChange)="lastSeenFrom.set($event)"
          [showClear]="true"
          placeholder="No limit"
          dateFormat="yy-mm-dd"/>
      </div>
      <div class="flex flex-col gap-1 flex-1">
        <label class="text-sm font-medium">Last seen to</label>
        <p-datepicker
          [ngModel]="lastSeenTo()"
          (ngModelChange)="lastSeenTo.set($event)"
          [showClear]="true"
          placeholder="No limit"
          dateFormat="yy-mm-dd"/>
      </div>
    </div>

    <div class="flex flex-row gap-4">
      <div class="flex flex-col gap-1 flex-1">
        <label class="text-sm font-medium">Created from</label>
        <p-datepicker
          [ngModel]="createdFrom()"
          (ngModelChange)="createdFrom.set($event)"
          [showClear]="true"
          placeholder="No limit"
          dateFormat="yy-mm-dd"/>
      </div>
      <div class="flex flex-col gap-1 flex-1">
        <label class="text-sm font-medium">Created to</label>
        <p-datepicker
          [ngModel]="createdTo()"
          (ngModelChange)="createdTo.set($event)"
          [showClear]="true"
          placeholder="No limit"
          dateFormat="yy-mm-dd"/>
      </div>
    </div>

    <admin-submit-button
      [label]="'Preview matching users'"
      [severity]="'secondary'"
      [submitFunction]="preview"
      [disabled]="previewLoading()"/>

    @if (previewLoading()) {
      <div class="bg-surface-100 rounded-lg p-4 flex items-center gap-2">
        <i class="pi pi-spin pi-spinner"></i>
        <p class="font-medium">Loading user preview...</p>
      </div>
    }

    @if (previewedUserIds(); as userIds) {
      <div class="bg-surface-100 rounded-lg p-4">
        <p class="font-medium">{{ userIds.length }} users match the filters</p>
      </div>

      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium">SMS message</label>
        <textarea
          pTextarea
          rows="3"
          class="w-full"
          [ngModel]="textMessage()"
          (ngModelChange)="textMessage.set($event)"
          placeholder="Leave empty to skip SMS"></textarea>
      </div>

      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium">Email template ID</label>
        <input
          pInputText
          class="w-full"
          [ngModel]="emailTemplateId()"
          (ngModelChange)="emailTemplateId.set($event)"
          placeholder="Leave empty to skip email"/>
      </div>

      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium">Push notification text</label>
        <textarea
          pTextarea
          rows="2"
          class="w-full"
          [ngModel]="pushText()"
          (ngModelChange)="pushText.set($event)"
          placeholder="Leave empty to skip push"></textarea>
      </div>

      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium">Notification category</label>
        <p-select
          [options]="categoryOptions"
          [ngModel]="category()"
          (ngModelChange)="category.set($event)"
          optionLabel="label"
          optionValue="value"
          placeholder="Core (always sent)"/>
      </div>

      <p class="text-sm text-orange-600">Warning: this will send real notifications to {{ userIds.length }} users.</p>

      <admin-submit-button
        [label]="'Send to ' + userIds.length + ' users'"
        [severity]="'primary'"
        [submitFunction]="send"
        [disabled]="!hasAnyChannel()"/>
    }
  </div>
</div>
